import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import { ErrorResponse } from '../../Interface/ErrorResponse';
import { PropertiesByCategory, Property } from '../../Interface/Response/ProductProperty/List/PropertiesByCategory';

import { errorHasBeenThrown } from '../../Store/Error/action';
import { getPropertiesByCategory } from '../../Service/ProductPropertiesAPIService';
import { propertiesLoaded } from '../../Store/Properties/action';

interface State {
    mortgageProperties: PropertiesByCategory[];
}

const useGetPropertiesByCategory = (): PropertiesByCategory[] => {
    const dispatch = useDispatch();
    const [state, setState] = useState<State>({ mortgageProperties: [] });

    useEffect(() => {
        getPropertiesByCategory().then(
            result => {
                setState({ ...state, mortgageProperties: result });
                const properties = result.reduce(
                    (acc: Property[], propertyByCategory) =>
                        [...acc, ...propertyByCategory.properties],
                    [],
                );
                dispatch(propertiesLoaded(properties));
            },
            (errorResult: ErrorResponse) => dispatch(errorHasBeenThrown(new Error(errorResult.message))),
        );
    }, []);

    return state.mortgageProperties;
};

export default useGetPropertiesByCategory;
